import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material';
import { TranslationsService } from 'src/app/translations/translations.service';
import { PatientAppExpandedModalComponent } from '../patient-app-expanded-modal/patient-app-expanded-modal.component';
import { WidgetCardColumn, WidgetCardConfig } from 'src/app/core/models/patient-app-widget.model';

@Component({
  selector: 'csi-patient-app-widget-card',
  templateUrl: './patient-app-widget-card.component.html',
  styleUrls: ['./patient-app-widget-card.component.scss']
})
export class PatientAppWidgetCardComponent implements OnChanges {
  @Input() card: WidgetCardConfig;
  public readonly translocoFileKey = 'dashboard.';
  columnDefs: string[] = [];
  lowerCaseTitle = '';

  constructor(public dialog: MatDialog, public translationsService: TranslationsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.card) {
      this.columnDefs =
        this.card && this.card.content ? this.card.content.map(col => col.heading) : [];
      this.lowerCaseTitle = this.card && this.card.title ? this.card.title.toLowerCase() : '';
    }
  }

  trackByHeading(index: number, col: WidgetCardColumn): string {
    return col.heading;
  }

  expandCard() {
    PatientAppExpandedModalComponent.open(this.dialog, this.card);
  }
}
